import {navigate, navigateModal, trackAnalyticsEvent} from '@eitje/bridge'

export const useGetLayoutClickHandler = ({onClick, to, modalLink, externalLink, analytics, navigateOptions}) => {
	const clickHandler = getClickHandler({onClick, to, modalLink, externalLink, navigateOptions})

	if (!clickHandler) return null

	if (!analytics) return clickHandler

	return (...args) => {
		clickHandler(...args)
		// we rely on trackAnalyticEvent not being set in the bridge of admin, so analytics work only on web implicitly
		trackAnalyticsEvent?.(analytics)
	}
}

const getClickHandler = ({onClick, to, modalLink, externalLink, navigateOptions}) => {
	if (onClick) return onClick
	if (to) return () => navigate(to, navigateOptions)
	if (externalLink) return () => window.open(externalLink, '_blank')
	if (modalLink) return () => navigateModal(modalLink, navigateOptions)
	return null
}
